export const AUTH_AUTHORITY = `${import.meta.env.VITE_APP_AUTH_URL}/realms/${import.meta.env.VITE_APP_AUTH_REALM}`;
